<div class="wrapper">
  @if (!hideLabel) {
    <div class="location-section-label">LOCATION:</div>
  }
  <div class="location-row" [class.has-details]="locationText || hasStationRange()">
    <mat-icon
      class="delete-location"
      [class.editable]="isEditable"
      svgIcon="trash"
      (click)="isEditable && deleteLocation($event)"
    />
    @if (hasCapture) {
      <!-- Spec addendum §11: the marked-up capture in place of the minimap, same size, cover-cropped on the pin. Its
           click opens the full picture (Sri 2026-09-28); the rest of the row still opens the picker. -->
      <app-design-capture-preview class="location-tile" [link]="mapFeatureLink" height="80px" [viewOnClick]="true" />
    } @else if (hasGpsLocation()) {
      <app-location-picker
        class="location-tile"
        [isDialog]="false"
        [latitude]="latitude"
        [longitude]="longitude"
        height="80px"
        [readOnly]="true" />
    }
    @if (locationText || hasStationRange()) {
      <div class="location-details">
        @if (locationText) {
          <div class="location-text">{{ locationText }}</div>
        }
        @if (hasStationRange()) {
          <div class="station-range">
            @if (stationRange?.alignment) {
              <div class="station-row">
                <span class="station-label">Alignment</span>
                <span>{{ stationRange.alignment }}</span>
              </div>
            }
            @if (stationRange?.from?.station || getOffsetType(stationRange?.from) || getOffsetDistance(stationRange?.from)) {
              <div class="station-row">
                <span class="station-label">From</span>
                <span>
                  {{ stationRange?.from?.station }}
                  @if (getOffsetType(stationRange?.from)) {
                    <span>, {{ getOffsetType(stationRange?.from) }}</span>
                  }
                  @if (getOffsetDistance(stationRange?.from)) {
                    <span>, {{ getOffsetDistance(stationRange?.from) }}</span>
                  }
                </span>
              </div>
            }
            @if (stationRange?.to?.station || getOffsetType(stationRange?.to) || getOffsetDistance(stationRange?.to)) {
              <div class="station-row">
                <span class="station-label">To</span>
                <span>
                  {{ stationRange?.to?.station }}
                  @if (getOffsetType(stationRange?.to)) {
                    <span>, {{ getOffsetType(stationRange?.to) }}</span>
                  }
                  @if (getOffsetDistance(stationRange?.to)) {
                    <span>, {{ getOffsetDistance(stationRange?.to) }}</span>
                  }
                </span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
